<div class="row" *ngIf="(quoteOrderLine | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-4">
                <label class="fw-bold">Event Type</label><br />
                <select name="orderEventType" class="form-control" [(ngModel)]="sched.orderEventTypeID" class="form-select" required>
                    <option *ngFor="let item of orderEventTypeList" value="{{item.orderEventTypeID}}">{{item.code}}</option>
                </select>
            </div>
            <div class="col-sm-4">
                <label class="fw-bold">Multiple?</label><br />
                <input type="checkbox" [(ngModel)]="sched.isMultiple" />
            </div>
            <div class="col-sm-4">
                <label class="fw-bold" *ngIf="sched.isMultiple">Hours To Check</label><br />
                <label class="fw-bold" *ngIf="!sched.isMultiple">Hours After First Pick</label><br />
                <input type="number" class="form-control" [(ngModel)]="sched.hoursToCheck" min="0" step="1" required />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <label class="fw-bold">Notes</label><br />
            <textarea class="form-control" [(ngModel)]="sched.notes" cols="60" rows="3"></textarea>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <label class="fw-bold">Email Subject</label><br />
            <textarea class="form-control" [(ngModel)]="sched.instructions" cols="60" rows="3"></textarea>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <label class="fw-bold">Notification Emails</label>
            <span matTooltip="Enter multple emails separated by a comma (',')"><i class="far fa-question-circle text-primary"></i></span>
            <br />
            <input type="text" class="form-control" [(ngModel)]="sched.notificationEmails" />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 m-2">
            <button class="btn btn-primary m-2" (click)="save()">Save</button>
            <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>
